import { useState, useEffect } from "react";
import { Card } from "@material-ui/core";
import { Hint, RadialChart } from "react-vis";
import "react-vis/dist/style.css";
import UserService from "../../services/user-service";
import "../../styling/sidebar.css";
import { Col, Row } from "react-bootstrap";
import SalesLogChart from "../Charts/SalesLogChart";

var total = 0;
var cardData1: any = [];
var cardData2: any = [];

function createData(name, date, amount, site, category, note) {
  return { name, date, amount, site, category, note };
}
const colors = [
  "#21A179",
  "#7964D9",
  "#EB6F2D",
  "#98B514",
  "#0DA4B5",
  "#FFD436",
  "#FAAC02",
  "#EA4147",
  "#FC6897",
  "#006895",
];

function createData2(name, amount, index) {
  var colorindex = 0;
  if (index >= colors.length) {
    colorindex = index % colors.length;
  } else {
    colorindex = index;
  }
  return {
    label: name,
    angle: amount,
    subLabel: amount,
    color: colors[colorindex],
  };
}

function percentage(amount) {
  var temp = ((parseFloat(amount) / total) * 100).toFixed(1);
  return temp + "%";
}

function round(amount) {
  return "$" + parseFloat(amount).toFixed(2);
}

const rows = [
  createData(
    "Hand plane",
    "4/9/21",
    "$10.00",
    "Lowe's",
    "Workshop tools",
    "Replacement"
  ),
  createData("Oak 4 x 4 x 4", "4/21/21", "$37.00", "Lowe's", "Lumber", 0),
  createData(
    "Dado blade",
    "5/10/21",
    "$50.00",
    "Lowe's",
    "Workshop tools",
    "Drawer"
  ),
  createData("Sandpaper", "6/9/21", "$10.00", "Lowe's", "Supplies", "Bench"),
];

function PieChart(props) {
  const [, setToLoading] = useState(true);
  const [nrows, setnRows] = useState(rows);
  const [value, setValue] = useState<any>({});
  const categoryType: any = props.categoryType;
  total = 0;

  useEffect(() => {
    UserService.getSale().then((response) => {
      const filtered = UserService.getSpecificSale(
        response.data.sale,
        props.stream + 1
      );
      setnRows(filtered);
      setToLoading(false);
    });
  }, [props.stream,props.reloadAPI]);

  var dict = {};
  Array.from(nrows).map(function (e) {
    const amount = parseFloat(e.amount);
    switch (categoryType) {
      case "category":
        e.note in dict
          ? (dict[e.note] = dict[e.note] + amount)
          : (dict[e.note] = amount);
        break;
      case "item name":
        e.name in dict
          ? (dict[e.name] = dict[e.name] + amount)
          : (dict[e.name] = amount);
        break;
      default:
        return null;
    }
  });

  if (nrows.length == 0) {
    return <div></div>;
  }

  cardData1 = Object.keys(dict).slice(0, Object.keys(dict).length / 2);
  cardData2 = Object.keys(dict).slice(
    Object.keys(dict).length / 2,
    Object.keys(dict).length
  );

  return (
    <Row className="mb-5">
      <Col xl={8} lg={6} md={12} className="d-flex justify-content-center">
        <div>
          <h4 className="graph-header">View Percentage Breakdown of Sales</h4>
          <SalesLogChart
            data={Object.keys(dict).map((nrow, index) => {
              total += dict[nrow];
              return createData2(nrow, dict[nrow], index);
            })}
          />
          {/*<RadialChart*/}
          {/*  data={Object.keys(dict).map((nrow, index) => {*/}
          {/*    total += dict[nrow];*/}
          {/*    return createData2(nrow, dict[nrow], index);*/}
          {/*  })}*/}
          {/*  width={670}*/}
          {/*  height={300}*/}
          {/*  onValueMouseOver={(datapoint, event) => {*/}
          {/*    setValue({ ...datapoint }); // Some SVG element*/}
          {/*  }} // Some SVG element*/}
          {/*  onSeriesMouseOut={() => {*/}
          {/*    setValue({});*/}
          {/*  }}*/}
          {/*  colorType="literal"*/}
          {/*>*/}
          {/*  {Object.keys(value).length !== 0 && (*/}
          {/*    <Hint value={value}>*/}
          {/*      <div className="graph-hint">*/}
          {/*        <p className="graph-hint-name">*/}
          {/*          {round(value.subLabel.toFixed(2))}*/}
          {/*        </p>*/}
          {/*        <p className="graph-hint-percentage">*/}
          {/*          {percentage(value.subLabel)}*/}
          {/*        </p>*/}
          {/*      </div>*/}
          {/*    </Hint>*/}
          {/*  )}*/}
          {/*</RadialChart>*/}
        </div>
      </Col>
      <Col xl={4} lg={5} md={12}>
        <div className="card-section">
         <h5 className="font-weight-bold mb-2">Note</h5>
          {Object.keys(dict).length <= 8 ? (
            <Card className="card-content">
              <div className="pl-2">
                {Object.keys(dict).map((nrow, index) => {
                  let data = createData2(nrow, dict[nrow], index);
                  return (
                    <div className="piechart-legends" key={index}>
                      <p
                        style={{
                          backgroundColor: data.color,
                          width: 20,
                          height: 20,
                          marginBottom: 10,
                        }}
                      />
                      <p className="name-content">
                        {percentage(data.subLabel)} -
                        {data.label.length > 10
                          ? data.label.slice(0, 10) + "..."
                          : data.label}
                      </p>
                    </div>
                  );
                })}
              </div>
            </Card>
          ) : (
            <div className="d-flex justify-content-around mt-3">
              <Card className="card-content mr-4 mt-3">
                <div className="pl-2 card-main-content">
                  {cardData1.map((nrow, index) => {
                    let data = createData2(nrow, dict[nrow], index);
                    return (
                      <div className="piechart-legends" key={index}>
                        <p
                          style={{
                            backgroundColor: data.color,
                            width: 20,
                            height: 20,
                            marginBottom: 10,
                          }}
                        />
                        <p className="name-content">
                          {percentage(data.subLabel)} -
                          {data.label.length > 10
                            ? data.label.slice(0, 10) + "..."
                            : data.label}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </Card>
              <Card className="card-content mr-4 mt-3">
                <div className="pl-2 card-main-content">
                  {cardData2.map((nrow, index) => {
                    let data = createData2(
                      nrow,
                      dict[nrow],
                      index + cardData1.length
                    );
                    return (
                      <div className="piechart-legends" key={index}>
                        <p
                          style={{
                            backgroundColor: data.color,
                            width: 20,
                            height: 20,
                            marginBottom: 10,
                          }}
                        />
                        <p className="name-content">
                          {percentage(data.subLabel)} -
                          {data.label.length > 10
                            ? data.label.slice(0, 10) + "..."
                            : data.label}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </Card>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
}
export default PieChart;
